import { setScrollTrigger } from "./parts/settings/gsap/scrolltrigger";
import { params } from "./parts/vars/params";
import { elms } from "./parts/vars/elms";
import { resize } from "./parts/utils/resize";
import { setResize } from "./parts/utils/set-resize";
// import { updateSvgScale } from "./parts/utils/svg-scale";
import { ham } from "./parts/components/common/ham";
import { marquee } from "./parts/components/common/marquee";
import { para } from "./parts/components/common/para";
import { scrollIn } from "./parts/components/common/scrollIn";
import { tabs } from "./parts/components/common/tabs";
import { accordion } from "./parts/components/common/accordion";
import { copyright } from "./parts/components/common/copyright";
import { scrollTo } from "./parts/components/common/scrollTo";
import { slider } from "./parts/components/common/slider";
import { mv } from "./parts/components/top/mv";
import { products } from "./parts/components/products/products";
import { shadow } from "./parts/components/common/shadow";
// import {twoDigits, addComma, inArray} from './lib/utils';
// {twoDigits, addComma, inArray}

const userAgent = navigator.userAgent.toLowerCase();
const isMobile = /iphone|ipod|ipad|android/.test(userAgent);
const bodyClass = isMobile ? "mobile" : "pc";
document.body.classList.add(bodyClass);

let initialized: boolean = false;

setTimeout(() => {
  init();
}, 3000);

window.addEventListener("load", () => {
  init();
  params.loadingComplete = true;
});

const init = (): void => {
  if (initialized) {
    return;
  }

  // console.log("Initializing...", initialized);
  initialized = true;

  if (elms.ham) ham();
  scrollTo();
  marquee();
  scrollIn();
  tabs();
  accordion();
  copyright();
  slider();
  mv();
  products();
  setScrollTrigger();
  resize();
  para();
  shadow();
  // Initial SVG scaling
  // updateSvgScale();
  setResize();
  document.body.classList.add("initialized");
};
